import React from "react";
import { LoadingDots, PageNotFound } from "@sscs/ui";
import { redirect } from "react-router";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES } from "../../constants";
import Behaviors from "../behaviour/BehaviorTabContent";
import FileChangesTab from "../diff/versionDiff/FileChangesTab";
import IssueChangesTab from "../diff/versionDiff/IssueChangesTab";
import ThreatHuntingTab from "../diff/versionDiff/ThreatHuntingTab";
import VersionDiff, { VersionDiffIndex } from "../diff/versionDiff/VersionDiff";
import ExtractedFiles from "../extractedFiles/ExtractedFilesTabContent";
import FBBehavior from "../fileBrowser/behavior/Behavior";
import FBDependencies from "../fileBrowser/dependencies/Dependencies";
import FBEvents from "../fileBrowser/events/Events";
import FileBrowser from "../fileBrowser/FileBrowser";
import FileDetails from "../fileBrowser/FileDetails";
import FBInfo from "../fileBrowser/info/Info";
import FBIssues from "../fileBrowser/issues/Issues";
import FBNetworking from "../fileBrowser/networking/Networking";
import FBSecrets from "../fileBrowser/secrets/Secrets";
import FBSignatures from "../fileBrowser/signatures/Signatures";
import FBVulnerabilities from "../fileBrowser/vulnerabilities/Vulnerabilities";
import Issues from "../issues/IssuesTabContent";
import Licenses from "../licenses/Licenses";
import Malware from "../malware/Malware";
import Networking from "../networking/Networking";
import Policies from "../policies/Policies";
import ReproChangesTab from "../reproducibility/ReproChangesTab";
import Reproducibility, { ReproducibilityIndex, } from "../reproducibility/Reproducibility";
import ReproIssuesTab from "../reproducibility/ReproIssuesTab";
import ReproModifiedFilesTab from "../reproducibility/ReproModifiedFilesTab";
import Secrets from "../secrets/SecretsTabContent";
import Signatures from "../signatures/Signatures";
import ReportSummary from "../summary/ReportSummary";
import Vulnerabilities from "../vulnerabilities/VulnerabilitiesTab";
import CBOM from "../xbom/cbom/CBOM";
import MLBOM from "../xbom/mlbom/MLBOM";
import SaaSBOM from "../xbom/saasbom/SaaSBOM";
import SBOM from "../xbom/sbom/SBOM";
export const ReportPages = {
    Behaviors,
    CBOM,
    ExtractedFiles,
    FileBrowser,
    FileDetails,
    FileChangesTab,
    Issues,
    IssueChangesTab,
    Malware,
    MLBOM,
    Networking,
    Policies,
    Licenses,
    ReportSummary,
    Reproducibility,
    ReproducibilityIndex,
    ReproIssuesTab,
    ReproChangesTab,
    ReproModifiedFilesTab,
    SaaSBOM,
    SBOM,
    Secrets,
    Signatures,
    ThreatHuntingTab,
    VersionDiff,
    VersionDiffIndex,
    Vulnerabilities,
};
export const FileBrowserPages = {
    Behavior: FBBehavior,
    Dependencies: FBDependencies,
    Events: FBEvents,
    Info: FBInfo,
    Issues: FBIssues,
    Networking: FBNetworking,
    Secrets: FBSecrets,
    Signatures: FBSignatures,
    Vulnerabilities: FBVulnerabilities,
};
export const generateReportRoutes = (basePath, ReportRoot) => [
    {
        path: basePath,
        element: ReportRoot,
        children: [
            {
                index: true,
                element: React.createElement(ReportPages.ReportSummary, null),
            },
            {
                path: REPORT_PAGES_ROUTES.SBOM_ROUTE,
                element: React.createElement(ReportPages.SBOM, null),
            },
            {
                path: REPORT_PAGES_ROUTES.SAASBOM_ROUTE,
                element: React.createElement(ReportPages.SaaSBOM, null),
            },
            {
                path: REPORT_PAGES_ROUTES.MLBOM_ROUTE,
                element: React.createElement(ReportPages.MLBOM, null),
            },
            {
                path: REPORT_PAGES_ROUTES.CBOM_ROUTE,
                element: React.createElement(ReportPages.CBOM, null),
            },
            {
                path: REPORT_PAGES_ROUTES.ISSUES_ROUTE,
                element: React.createElement(ReportPages.Issues, null),
            },
            {
                path: REPORT_PAGES_ROUTES.MALWARE_ROUTE,
                element: React.createElement(ReportPages.Malware, null),
            },
            {
                path: REPORT_PAGES_ROUTES.VULNERABILITIES_ROUTE,
                element: React.createElement(ReportPages.Vulnerabilities, null),
            },
            {
                path: REPORT_PAGES_ROUTES.SECRETS_ROUTE,
                element: React.createElement(ReportPages.Secrets, null),
            },
            {
                path: REPORT_PAGES_ROUTES.SIGNATURES_ROUTE,
                element: React.createElement(ReportPages.Signatures, null),
            },
            {
                path: REPORT_PAGES_ROUTES.VERSION_DIFF,
                element: React.createElement(ReportPages.VersionDiff, null),
                children: [
                    {
                        index: true,
                        element: React.createElement(ReportPages.VersionDiffIndex, null),
                    },
                    {
                        path: REPORT_PAGES_ROUTES.VERSION_DIFF_THREAT_HUNTING,
                        element: React.createElement(ReportPages.ThreatHuntingTab, null),
                    },
                    {
                        path: REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES,
                        element: React.createElement(ReportPages.IssueChangesTab, null),
                    },
                    {
                        path: REPORT_PAGES_ROUTES.VERSION_DIFF_FILE_CHANGES,
                        element: React.createElement(ReportPages.FileChangesTab, null),
                    },
                ],
            },
            {
                path: REPORT_PAGES_ROUTES.ISSUES_DIFF,
                loader: async ({ request }) => redirect(`../${REPORT_PAGES_ROUTES.VERSION_DIFF}/${REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES}${new URL(request.url).search}`),
            },
            {
                path: REPORT_PAGES_ROUTES.FILES_DIFF,
                loader: async ({ request }) => redirect(`../${REPORT_PAGES_ROUTES.VERSION_DIFF}/${REPORT_PAGES_ROUTES.VERSION_DIFF_FILE_CHANGES}${new URL(request.url).search}`),
            },
            {
                path: REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE,
                element: React.createElement(ReportPages.Reproducibility, null),
                children: [
                    {
                        index: true,
                        element: React.createElement(ReportPages.ReproducibilityIndex, null),
                    },
                    {
                        path: REPORT_PAGES_ROUTES.REPRODUCIBILITY_ISSUES,
                        element: React.createElement(ReportPages.ReproIssuesTab, null),
                    },
                    {
                        path: REPORT_PAGES_ROUTES.REPRODUCIBILITY_CHANGES,
                        element: React.createElement(ReportPages.ReproChangesTab, null),
                    },
                    {
                        path: REPORT_PAGES_ROUTES.REPRODUCIBILITY_MODIFIED_FILES,
                        element: React.createElement(ReportPages.ReproModifiedFilesTab, null),
                    },
                ],
            },
            {
                path: REPORT_PAGES_ROUTES.BEHAVIOR_ROUTE,
                element: React.createElement(ReportPages.Behaviors, null),
            },
            {
                path: REPORT_PAGES_ROUTES.NETWORKING_ROUTE,
                element: React.createElement(ReportPages.Networking, null),
            },
            {
                path: REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE,
                element: React.createElement(ReportPages.FileBrowser, null),
                children: [
                    {
                        path: ":fileId",
                        element: React.createElement(ReportPages.FileDetails, null),
                        children: [
                            {
                                path: FILE_BROWSER_ROUTES.INFO_ROUTE,
                                element: React.createElement(FileBrowserPages.Info, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.BEHAVIOR_ROUTE,
                                element: React.createElement(FileBrowserPages.Behavior, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.DEPENDENCIES_ROUTE,
                                element: React.createElement(FileBrowserPages.Dependencies, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.ISSUES_ROUTE,
                                element: React.createElement(FileBrowserPages.Issues, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.NETWORKING_ROUTE,
                                element: React.createElement(FileBrowserPages.Networking, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.SECRETS_ROUTE,
                                element: React.createElement(FileBrowserPages.Secrets, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.SIGNATURES_ROUTE,
                                element: React.createElement(FileBrowserPages.Signatures, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.VULNERABILITIES_ROUTE,
                                element: React.createElement(FileBrowserPages.Vulnerabilities, null),
                            },
                            {
                                path: FILE_BROWSER_ROUTES.EVENTS_ROUTE,
                                element: React.createElement(FileBrowserPages.Events, null),
                            },
                        ],
                    },
                ],
            },
            {
                path: REPORT_PAGES_ROUTES.POLICIES_ROUTE,
                element: React.createElement(ReportPages.Policies, null),
            },
            {
                path: REPORT_PAGES_ROUTES.LICENSES_ROUTE,
                element: React.createElement(ReportPages.Licenses, null),
            },
            {
                path: REPORT_PAGES_ROUTES.STATISTICS_ROUTE,
                element: React.createElement(ReportPages.ExtractedFiles, null),
            },
            {
                // Redirect to the new route to ensure backwards compatibility
                path: "files",
                loader: async () => redirect(`../${REPORT_PAGES_ROUTES.STATISTICS_ROUTE}`),
                hydrateFallbackElement: React.createElement(LoadingDots, null),
            },
            {
                path: "*",
                element: (React.createElement(PageNotFound, { title: "Page not found", byline: "This report has no such page. Pick a section from the report navigation." })),
            },
        ],
    },
];
//# sourceMappingURL=index.js.map